module.exports = __webpack_public_path__ + "img/home.108d05c6.svg";